<div nz-row class="data-section w-full" nzAlign="middle">
  <div nz-col nzSpan="24" class="no-form" style="margin-bottom: 1rem;">
    <h1 i18n="Identity.PersonalData.Title|title for personal data page@@Identity.PersonalData.Title">Dashboard</h1>
  </div>
  <!-- <div nz-col nzSpan="24" class="no-form">
    <h3 i18n="Identity.PersonalData.Subtitle|subtitle for personal data page@@Identity.PersonalData.Subtitle"
      class="data-section-title">Dati anagrafici</h3>
  </div> -->
  <!--<div nz-col class="user-image-box">
    <div class="user-image-wrapper">
      <img nz-image class="user-image"
        src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1834&q=80" />
      <div class="gender-symbol">
        <i nz-icon nzType="man" nzTheme="outline"></i>
      </div>
    </div>
  </div>-->
  <div nz-col nzFlex="auto" class="no-form">
    <div class="user-data">
      <h2>{{currentUser.first_name}} {{currentUser.last_name}}</h2>
      <span style="font-size: 14px;">Nato il {{currentUser.birth_date | date:'dd/MM/yyyy'}}</span>
      <span style="font-size: 14px;">a {{currentUser.birthPlace?.city}} ({{currentUser.birthPlace?.province}}),
        {{currentUser.birthPlace?.country}}</span>
      <span style="font-size: 14px;">{{currentUser.fiscal_code}}</span>
    </div>
  </div>
</div>

<div nz-row nzJustify="center" [nzGutter]="[32, 32]" class="w-full">
  <div nz-col class="data-column" nzSpan="12">
    <h3
      i18n="Identity.PersonalData.LegalAddressData|label for legal address data@@Identity.PersonalData.LegalAddressData"
      class="data-section-title">Dati residenza</h3>
    <div class="data-box">
      <span class="data-type"
        i18n="Identity.PersonalData.CountryAndState|label for country and state@@Identity.PersonalData.CountryAndState">Stato
        e Provincia</span>
      <span class="data-value">{{currentUser.legalAddress?.country}} - {{currentUser.legalAddress?.province}}</span>
    </div>
    <div class="data-box">
      <span class="data-type"
        i18n="Identity.PersonalData.CityAndZipCode|label for city and zip code@@Identity.PersonalData.CityAndZipCode">Comune
        e CAP</span>
      <span class="data-value">{{currentUser.legalAddress?.city}} - {{currentUser.legalAddress?.postal_code}}</span>
    </div>
    <div class="data-box">
      <span class="data-type"
        i18n="Identity.PersonalData.Address|label for address@@Identity.PersonalData.Address">Indirizzo</span>
      <span class="data-value">{{currentUser.legalAddress?.address}}</span>
    </div>
  </div>
  <div nz-col nzSpan="12">
    <h3 class="data-section-title"
      i18n="Identity.PersonalData.Contacts|label for contact section@@Identity.PersonalData.Contacts">Contatti</h3>
    <div class="data-box">
      <span class="data-type"
        i18n="Identity.PersonalData.Email|label for email@@Identity.PersonalData.Email">Email</span>
      <span class="data-value">{{currentUser.email}}</span>
    </div>
    <div class="data-box">
      <span class="data-type"
        i18n="Identity.PersonalData.phone_number|label for mobile phone@@Identity.PersonalData.phone_number">Telefono
        cellulare</span>
      <span class="data-value">{{currentUser.phone_number}}</span>
    </div>
    <div *ngIf="currentUser.phone" class="data-box">
      <span class="data-type">Telefono fisso</span>
      <span class="data-value">{{currentUser.phone}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Notifiche</span>
      <span class="data-value">
        <nz-switch (ngModelChange)="onChangeEmailNotifications($event)" [(ngModel)]="currentUser.email_notifications">
        </nz-switch>
      </span>
    </div>
  </div>

  <div *ngIf="currentUser.company" nz-col class="data-column" nzSpan="12">
    <h3 class="data-section-title">Dati azienda</h3>
    <div class="data-box">
      <span class="data-type">Codice fiscale o P.iva</span>
      <span class="data-value">{{currentUser.company.vat_number}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Nome</span>
      <span class="data-value">{{currentUser.company.name}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Domicilio Digitale</span>
      <span class="data-value">{{currentUser.pec}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Codice postale</span>
      <span class="data-value">{{currentUser.company.postal_code}}</span>
    </div>
  </div>
  <div *ngIf="currentUser.company" nz-col nzSpan="12">
    <h3 class="data-section-title" style="visibility: hidden;">a</h3>
    <div class="data-box">
      <span class="data-type">Indirizzo</span>
      <span class="data-value">{{currentUser.company.address}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Città</span>
      <span class="data-value">{{currentUser.company.city}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Provincia</span>
      <span class="data-value">{{currentUser.company.province}}</span>
    </div>
    <div class="data-box">
      <span class="data-type">Paese</span>
      <span class="data-value">{{currentUser.company.country}}</span>
    </div>
  </div>
</div>

<div nz-row nzJustify="center" [nzGutter]="32" class="w-full">
  <div nz-col class="document-section" nzSpan="24">
    <h3 class="data-section-title" style="margin: 0;"
      i18n="Identity.PersonalData.Document|label for document section@@Identity.PersonalData.Document">Documenti</h3>
  </div>
  <div nz-col class="document-section" nzSpan="12">
    <!-- <h3 class="data-section-title"
      i18n="Identity.PersonalData.Document|label for document section@@Identity.PersonalData.Document">Documento
      registrato</h3> -->
    <div class="data-box docs-data no-wrap">
      <div class="document-image-box">
        <img *ngIf="currentUser.identityDocument.document_type === 'IC'" nz-image nzDisablePreview="true"
          class="document-image" nzSrc="assets/img/cie.svg" />
        <img *ngIf="currentUser.identityDocument.document_type === 'PS'" nz-image nzDisablePreview="true"
          class="document-image" nzSrc="assets/img/passaporto.svg" />
        <img *ngIf="currentUser.identityDocument.document_type === 'DL'" nz-image nzDisablePreview="true"
          class="document-image" nzSrc="assets/img/patente.svg" />
      </div>
      <div class="document-data">
        <h2>{{getDisplaydocument_type(currentUser.identityDocument.document_type)}}</h2>
        <span>{{currentUser.identityDocument.document_number}} - {{currentUser.identityDocument.document_issuer}}</span>
        <span>Rilasciato il {{currentUser.identityDocument.document_issue_date | date:'dd/MM/YYYY'}}</span>
        <span>Valido fino al {{currentUser.identityDocument.document_expiration_date | date:'dd/MM/YYYY'}}</span>
      </div>

    </div>
  </div>

  <div nz-col class="document-section" nzSpan="12">
    <!-- <h3 class="data-section-title">Tessera sanitaria</h3> -->
    <div class="data-box docs-data no-wrap">
      <div class="document-image-box">
        <img nz-image nzDisablePreview="true" class="document-image" nzSrc="assets/img/cns.svg" />
      </div>
      <div class="document-data">
        <h2>Tessera sanitaria</h2>
        <span>Codice fiscale {{currentUser.fiscal_code}}</span>
        <span>Data di scadenza {{currentUser.fiscal_code_card_expiration_date | date:'dd/MM/YYYY'}}</span>
        <span>Identificativo {{currentUser.fiscal_code_card_id}}</span>
      </div>
    </div>
  </div>
</div>

<div nz-row nzJustify="center" [nzGutter]="32" class="w-full">
  <div nz-col class="document-section" nzSpan="24">
    <a href="{{ logoutSso }}">
      <h3 class="data-section-title" style="margin: 0;">
        Single Logout SPID di livello 1
      </h3>
    </a>
    <a (click)="downloadContract()">
      <h3 class="data-section-title" style="margin: 0;"
        i18n="Identity.PersonalData.Contract|label for contract section@@Identity.PersonalData.Contract">Scarica il
        contratto
        <i nz-icon nzType="file-text" nzTheme="outline"></i>
      </h3>
    </a>
  </div>
</div>
